import React from 'react';
import { motion } from 'framer-motion';

const LOGO_INITIAL = { scale: 0, rotate: -180 };
const LOGO_ANIMATE = { scale: 1, rotate: 0 };
const LOGO_TRANSITION = { duration: 0.6, delay: 0.1, type: 'spring' };
const TITLE_INITIAL = { opacity: 0, y: 20 };
const TITLE_ANIMATE = { opacity: 1, y: 0 };
const TITLE_TRANSITION = { duration: 0.5, delay: 0.3 };
const TAGLINE_INITIAL = { opacity: 0 };
const TAGLINE_ANIMATE = { opacity: 1 };
const TAGLINE_TRANSITION = { duration: 0.5, delay: 0.5 };

export const HeroLogo = ({ restaurantName, tagline }) => (
  <div className="flex items-center gap-4">
    <motion.div
      initial={LOGO_INITIAL}
      animate={LOGO_ANIMATE}
      transition={LOGO_TRANSITION}
      className="h-20 w-20 md:h-24 md:w-24 rounded-2xl overflow-hidden flex items-center justify-center"
    >
      <img
        src="/mirnas-logo.png"
        alt="Mirna's Pizza Logo"
        className="h-full w-full object-contain"
      />
    </motion.div>
    <div>
      <motion.h2
        className="text-3xl md:text-4xl lg:text-5xl font-black tracking-tight leading-tight"
        initial={TITLE_INITIAL}
        animate={TITLE_ANIMATE}
        transition={TITLE_TRANSITION}
      >
        {restaurantName}
      </motion.h2>
      <motion.p
        className="mt-2 text-base md:text-lg text-foreground/70"
        initial={TAGLINE_INITIAL}
        animate={TAGLINE_ANIMATE}
        transition={TAGLINE_TRANSITION}
      >
        {tagline}
      </motion.p>
    </div>
  </div>
);
